const manageHandleErrorService = (customErrors, $log) => {
    // customReasons should be passed to the main parameter
    // and passed by composition
    // but there was something wrong or Angular does not accept it
    return {
        handleServerError: (fieldErrors) => {
            if(!Array.isArray(fieldErrors)) {
                $log.error('fieldErrors should be an array');
                return {}
            }
            return fieldErrors.reduce((acc, val) => {
                if(customErrors) {
                    const key = Object.keys(customErrors)
                        .find(key => new RegExp(key).test(val.reason));

                    acc[val.field] = key ? customErrors[key] : val.reason;
                    return acc;
                } else {
                    $log.error('Customs Error should not be null');
                    return acc;
                }
            }, {});
        }
    }
};

angular
    .module('qkr')
    .factory('manageHandleErrorService', manageHandleErrorService);


// WEBPACK FOOTER //
// ./src/services/manage.handle.error.service.js